import React from 'react';
import '../styles/Marquee.css';

const Marquee = ({ text, scrollAmount = 30 }) => {
  // Animasyon süresini hesapla (minimum 15 saniye, maksimum 60 saniye)
  const duration = Math.max(15, Math.min(60, scrollAmount || 30));
  
  const marqueeStyle = {
    animationDuration: `${duration}s`,
  };

  return (
    <div className="marquee-container">
      <div className="marquee-content" style={marqueeStyle}>
        {text}
      </div>
    </div>
  );
};

export default Marquee;
